export class AppConstants {
	
        public static STATUS: any  = [
            {value: 0, name: 'Inactivo'},
            {value: 1, name: 'Activo'},
            {value: 2, name: 'Eliminado'},
        ];
		
        public static COUNTRIES: any  = [
            {value: 'CL', name: 'Chile', language: 'ES'},
            {value: 'PE', name: 'Perú', language: 'ES'},
            {value: 'BR', name: 'Brasil', language: 'PT'},
            {value: 'US', name: 'Estados Unidos', language: 'EN-US'},
            {value: 'US-TX', name: 'Estados Unidos - Texas', language: 'EN-US' },
        ];
		
        public static STATES: any  = {
            PENDING: 'state-pending',
			SUCCESS: 'state-success',
			DISABLED: 'state-disabled'
        };		
		
}
